import { StreamChat } from 'stream-chat';
import { Streami18n } from 'stream-chat-react';
import { ConnectionOpen } from 'stream-chat/src/types';
import localizedJP from './localizedJP.json';
import { initializeGraphqlClient } from 'src/client/graphql/client';
import { RequestChatTokenDocument } from 'src/client/generated';

export const createClient = (apiKey: string) => {
  return new StreamChat(apiKey);
};

export const createI18nJa = () => {
  const i18nJA = new Streami18n({
    ...localizedJP,
    language: 'ja',
  });

  i18nJA.addOrUpdateLocale('ja', {
    calendar: {
      lastDay: '[昨日] LT',
      lastWeek: 'dddd LT',
      nextDay: '[明日] LT',
      nextWeek: '[次の] dddd LT',
      sameDay: '[今日] LT',
      sameElse: 'L',
    },
  } as Partial<ILocale>);
  return i18nJA;
};

export const extractUnreadCount = (mayBeConnectionOpen: ConnectionOpen | void): number => {
  if (mayBeConnectionOpen == undefined) {
    return 0;
  }
  if (mayBeConnectionOpen.me == null) {
    return 0;
  }
  return mayBeConnectionOpen.me.total_unread_count;
};

const decodeJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  return JSON.parse(decodeURIComponent(escape(window.atob(base64))));
};

export const setChatUser = async (
  token: string,
  user: { id: string; name?: string; image?: string },
  chatClient: StreamChat,
) => {
  if (chatClient.setUserPromise) {
    chatClient.upsertUser(user);
    return chatClient.setUserPromise;
  }
  const setUserRes = await chatClient.connectUser(user, async () => {
    const chatUserKey = `chat-token-${user.id}`;
    const cachedChatToken = localStorage.getItem(chatUserKey);

    clearChatTokenCache(chatUserKey);

    if (cachedChatToken) {
      const { exp } = decodeJwt(cachedChatToken);
      const isExpired = Date.now() > exp * 1000;
      if (!isExpired) {
        return cachedChatToken;
      }
    }
    const graphqlClient = initializeGraphqlClient(null, token);
    const { data } = await graphqlClient.mutate({
      mutation: RequestChatTokenDocument,
    });
    const chatToken = data?.requestChatToken?.token || '';
    localStorage.setItem(chatUserKey, chatToken);
    return chatToken;
  });

  return setUserRes;
};

export const clearChatTokenCache = (exceptKey?: string) => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.match(/^chat-token-/) != null && key !== exceptKey) {
      localStorage.removeItem(key);
    }
  }
};
